import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import * as Topics from "Data/Topics";
import { Button } from "GameObjects/Button";
import { MusicManager } from "Singletons/MusicManager";
import { MusicGamePlayButton } from "GameObjects/MusicGame/Buttons/PlayButton";

export class MusicGamePlaybackPlayButton extends MusicGamePlayButton {
    protected onClick() {
        MusicManager.Instance.Play(true);
    }
}